import React from 'react'
import Navbar from './Nvabar/Navbar'
import Rout from './Rout'
import './App.css'
import Footer from './Footer/Footer'

const App = () => {
  return (
    <div>
      <Navbar />    
      <Rout />
      <Footer />
    </div>
  )
}

export default App